import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {FormProvider, useForm} from "react-hook-form";
import {emailValidator, passwordValidator, strongPasswordValidator, userNameValidator} from "../../Utils/index.js";
import validator from 'validator';

import inputTypes from '../../Components/Utils/Form/FormInput/inputTypes';
import Button from '../../Components/Utils/Button';
import LandingPageNav from "../../Components/LandingPageNav/index.jsx";


import two_iphones from '../../assets/two_iphones.svg';
import ev_logo from '../../assets/ev_logo_white.png';


import XFormInput from "../../Components/Utils/Form/XFormInput/index.jsx";
import { useRegisterUserMutation } from '../../redux/api/auth';
import { setUser } from '../../redux/reducers/authSlice';
import { selectAuthData } from '../../redux/selectors/auth';
import './style.scss';


function Register() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user: { email: userEmail = '' } = {} } = useSelector(selectAuthData);
  const [tokenUserEmail, setTokenUserEmail] = useState('')

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const decodeJWRToken = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  };

  const [registerUser, { data, error, isLoading, isSuccess }] = useRegisterUserMutation();
  const form = useForm({values:{email:tokenUserEmail}})
  const { handleSubmit, register, getValues, formState: {errors}} = form
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (token) {
      const decodedJwt = decodeJWRToken(token);
      setTokenUserEmail(decodedJwt.sub)
      if (decodedJwt.exp < Date.now() / 1000) {
        setErrorMessage('This link has expired. Please request a new one.');
      }
    }
  }, []);

  useEffect(() => {
    if (isSuccess) {
      // dispatch(setUser(data));
      // navigate('/dashboard');
      navigate('/login');

    }

  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      setErrorMessage(error.data?.message);
    }
  }, [error]);

  useEffect(() => {
    if (userEmail) {
      navigate('/dashboard');
    }
  }, [userEmail]);

  const onClickLogin = () => {
    navigate('/login');
  };

  const validatePasswords = () => {
    const password = getValues('password')
    const confirmationPassword = getValues('confirm_password')

    return password === confirmationPassword || 'The passwords doesn`t match'
  }

  const onSubmit = async (values) => {
    await registerUser({data:{
      userName: values.username,
      password: values.password,
      email: values.email,
    }, token:token});
  };

  //RENDER
  return (
      <div className={'register__page'}>
        <LandingPageNav/>
        <div className={'register__page__container'}>
        <div className={'register__description_section'}>
          <a href="/"> <img src={ev_logo} alt="logo"/></a>
          <h2>{t('welcome_to_ev')}</h2>
          <p>{t('thank_you_choosing_us')}</p>
          <div className={'register__description_section__img_container'}>
            <img src={two_iphones} alt="logo"/>
          </div>

        </div>
        <div className='register__container'>
          <div className={'register__text register__title'}>{t('become_a_member')}</div>
          <p className='register__text'>
            {t('register_text')}
          </p>
          <FormProvider {...form}>
            <form className='register__form' onSubmit={handleSubmit(onSubmit)}>
              <XFormInput
                  labelClass={'label_align_left'}
                  id={'username'}
                  type={inputTypes.text}
                  name={'username'}
                  label={t('alias')}
                  placeholder={'Type alias here...'}
                  ref={register('username', {
                    required: 'error_field_required',
                    validate: userNameValidator
                  })}
              />
              <XFormInput
                  labelClass={'label_align_left'}
                  id={'email'}
                  type={inputTypes.text}
                  disabled={token? true : false}
                  name={'email'}
                  label={t('email')}
                  placeholder='example@email.com'
                  ref={register('email', {
                    required: 'error_field_required',
                    validate: emailValidator
                  })}
              />
              <XFormInput
                labelClass={'label_align_left'}
                id="password"
                name="password"
                label={t('password')}
                type={inputTypes.password}
                placeholder={t('enter_password')}
                ref={register('password', {
                  required: 'error_field_required',
                  validate: strongPasswordValidator,
                })}
              />
              <XFormInput
                labelClass={'label_align_left'}
                id="confirm_password"
                name={'confirm_password'}
                label={t('confirm_password')}
                type={inputTypes.password}
                placeholder={t('enter_password')}
                ref={register('confirm_password', {
                  required: 'error_field_required',
                  validate: {
                    samePasswords: validatePasswords,
                  },
                })}
              />
              <Button
                className='button__charlie'
                label={t('register')}
                disabled={isLoading}
                type='submit'
              />
            </form>
          </FormProvider>
          <div className='register__error-text'>{errorMessage}</div>

          <div className='register__vertical-container register__login-container'>
            <p className='register__text'>{t('already_have_an_account')}</p>
            <Button
              label={t('login')}
              className='button__charlie'
              onClick={onClickLogin}
              disabled={isLoading}
            />
          </div>
        </div>
        </div>
      </div>
  );
}

export default Register;
